import { Box, Icon } from '@chakra-ui/react';
import { FaRobot } from 'react-icons/fa6';
import { FaUserAlt } from 'react-icons/fa';
import { useMemo } from 'react';

import { Paper } from '@app/components/common';

import { Message } from '../types';


type ChatMessageProps = Message;

export const ChatMessage = ({ message, from, date }: ChatMessageProps) => {

  const html = useMemo(() => marked(message), [message]);

  return <Box
    paddingLeft={from === 'user' ? 10 : 2}
    paddingRight={from === 'user' ? 2 : 10}
    display='flex'
    flexDirection='column'
    width='auto'
  >
    <Paper bgColor={ from === 'user' ? 'light.500' : 'white' }>
      <Box p={2} display='flex' flexDirection='column' gap={1}>
        <Box fontSize={12} color='brand.500' pr={2} display='flex' alignItems='baseline' gap={1}>
          {from === 'user' ? <Icon as={FaUserAlt} size='12px' color='brand.100' /> : <Icon as={FaRobot} size='16px' color='brand.100' />}
          {from === 'user' ? 'Вы:' : 'Бот:'}
        </Box>
        <Box whiteSpace='pre-wrap' fontSize={12}>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </Box>
      </Box>
    </Paper>
    <Box fontSize={10} color='gray.500' textAlign={from==='user' ? 'right' : 'left'} px={2}>{date}</Box>
  </Box>; 
};

function marked(message: string): any {
  return message
    .replaceAll(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)/g, '<a target="_blank" href="$&">$&</a>')
    .replaceAll(/\n/g, '<br>');

}